import { useEffect, useRef, useState } from 'react';
import {
    Container,
    Message,
    Content,
    Footer,
    Form,
    ButtonToolbar,
    Button,
    Navbar,
    Panel,
    FlexboxGrid
  } from 'rsuite';
  import {useNavigate} from 'react-router-dom';
  
  const ForgotPassword = () => {
    const [loading,setLoading] = useState(false);
    const [error,setError] = useState('');
    const [message,setMessage] = useState('');
    const [email,setEmail] = useState('')
    const [update,setUpdate] = useState(false);
    const navigate = useNavigate()

    const formData =  (formValue)=>{
      setEmail(formValue.email)
    }

    const handleSubmit = async()=>{

    }

    return(
    <div className="login-container">
      <Container>
        <Content>
          <FlexboxGrid justify="center" style={{height:'calc(100vh)',alignItems:'center'}}>
            <FlexboxGrid.Item colspan={8}>
            {message?
            <Message showIcon type="info">
                {message}
            </Message>
            :
            error?
            <Message showIcon type="error">
                {error}
            </Message>
            :
            ''
            }
              <Panel header={<h3>Login</h3>} >
                <Form fluid onChange={formData}>
                  <Form.Group>
                    <Form.ControlLabel>Email address</Form.ControlLabel>
                    <Form.Control name="email" />
                  </Form.Group>
                  <Form.Group>
                    <ButtonToolbar>
                      <Button appearance="primary" loading={loading} onClick={()=>handleSubmit()}>Reset Password</Button>
                      
                      <Button appearance="link" onClick={()=>navigate('/login')}>Login</Button>
                    </ButtonToolbar>
                  </Form.Group>
                </Form>
              </Panel>
            </FlexboxGrid.Item>
          </FlexboxGrid>
        </Content>
      </Container>
    </div>
  );
    }
  export default ForgotPassword;